module.exports = __webpack_public_path__ + "static/media/NetworkIcon.69f9f8af.svg";